module.exports = __webpack_public_path__ + "static/media/sz.cfb8269f.svg";